import {connect} from 'react-redux';
import {getTranslation} from "../../../../reducers/common/localization";
import HistoryConsentsList from "./HistoryConsentsList";
import {getConsentsData, getRequestsByStatus, loadingConsents} from "../../../../reducers/consent/consents";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: loadingConsents(state),
        data: getConsentsData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadData: (statuses) => dispatch(getRequestsByStatus(statuses))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryConsentsList);



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/historyConsentsList/HistoryConsentsList.container.js